import actionTypes from "../actionTypes";

export const eventGetMyDraftsAction = (data, count) => ({
  type: actionTypes.eventTypes.EVENT_GET_MY_DRAFTS,
  payload: data,
  count: count,
});

export const eventGetPublishedByMeAction = (data, count) => ({
  type: actionTypes.eventTypes.EVENT_PUBLISHED_BY_ME,
  payload: data,
  count: count,
});

export const eventGetPublishedByOthersAction = (data, count) => ({
  type: actionTypes.eventTypes.EVENT_PUBLISHED_BY_OTHERS,
  payload: data,
  count: count,
});

export const postLiveQuizEvent = (data) => ({
  type: actionTypes.eventTypes.POST_LIVE_QUIZ_EVENT,
  payload: data,
})

export const eventGetClassByTags = (data) => ({
  type: actionTypes.eventTypes.GET_CLASS_BY_TAGS_LiveTraining,
  payload: data,
});

export const eventGetClassByTagsVirtualTraining = (data) => ({
  type: actionTypes.eventTypes.GET_CLASS_BY_TAGS_VirtualTraining,
  payload: data,
});


export const eventAddQuizImageStoreAction = (data) => ({
  type: actionTypes.eventTypes.EVENT_ADD_QUIZ_IMAGE,
  payload: data,
});
